import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { Row, Col, Button, Card, Form, Modal, Table, ButtonToolbar, ToggleButtonGroup, ToggleButton, Tabs, Tab } from "react-bootstrap";
import { FaUser, FaUsers, FaTachometerAlt, FaInfoCircle } from "react-icons/fa";
import DataTable from "react-data-table-component";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { apiCall } from "../api/apiUtil";

function VendorReportPage() {
    const [userRoles, setUserRoles] = useState(null);
    const [totalVendorCount, setTotalVendorCount] = useState(0);
    const [exceptionVendorCount, setExceptionVendorCount] = useState(0);
    const [reportCount, setReportCount] = useState(0);
    const [isCompliance, setIsCompliance] = useState(false);
    const [selectedMonth, setSelectedMonth] = useState(new Date());    
    const [finYear, setFinYear] = useState("");
	const [tableData, setTableData] = useState([]);

    const getFinancialYear = (date) => {
        const year = date.getFullYear();
        const month = date.getMonth(); // 0 = Jan
        let fy = "";
        
        if (month >= 3) { // April or later
            fy = `${year}-${(year + 1).toString().slice(-2)}`;
        } else {
            fy = `${year - 1}-${year.toString().slice(-2)}`;
        }
        setFinYear(fy);        
        return fy;
    };

    const [selectedTab, setSelectedTab] = useState("VendorNonCompliances");

    const [showModal, setShowModal] = useState(false);
    const [modalTitle, setModalTitle] = useState("");
    const [modalContent, setModalContent] = useState("");

    const navigate = useNavigate();
    useEffect(() => {
        //console.log("Global Code", sessionStorage.getItem("globalCode"));
        let globalCode = sessionStorage.getItem("globalCode");
        if(globalCode) {
            //setGlobalCode(sessionStorage.getItem("globalCode"));
            setUserRoles(JSON.parse(sessionStorage.getItem("userRoles")));
            //getEmployeeNonComplianceLiveStatusMonthly();
        } else {
            navigate("/");
        }
    }, [navigate]);

    useEffect(() => {
        getFinancialYear(selectedMonth);
    }, [selectedMonth]);

    const getDetailReport = (isCompliance, isException) => {
        if(Array.isArray(userRoles)) {
			let filter = {
				year: finYear,
				orgUnits: [...new Set(userRoles.map(item => item.orgUnit).filter(e => e !== null && e !== undefined))],
				units: [...new Set(userRoles.map(item => item.locationName).filter(e => e !== null && e !== undefined))],
				isComplianced: isCompliance,
				isException: isException,
			}
            if(userRoles.some(role => role.role === "Auditor")) {
                filter.auditable = true;
            }
			apiCall(`/VendorCompliance/GetFilteredVendorCompliance`, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(filter),
			})
			.then((data) => {
				//console.log("Backend Response:", data);
				if (data.success) {
					setTotalVendorCount(data?.summary?.totalVendorCount ?? 0);
					setExceptionVendorCount(data?.summary?.exceptionVendorCount ?? 0);
					setReportCount(data?.summary?.vendorReportCount ?? 0);
					setTableData(data.vendors)
				} else {				
					alert(data.message);
				}
			})
			.catch((err) => {
				alert(err);
				console.error("Error:", err);
			});
		}
    }

    useEffect(() => {
		setTableData([]);
        setTotalVendorCount(0);
        setExceptionVendorCount(0);
        setReportCount(0);        
		if(selectedTab == "VendorNonCompliances") {
			getDetailReport(false, false);
		} else if(selectedTab == "VendorCompliances") {
			getDetailReport(true, false);
		} else if(selectedTab == "ExceptionVendors") {
			getDetailReport(false, true);
		}
		// else if(selectedTab == "ROHoldList") {
		// 	getRONonComplianceMonthlyFinal();
		// } else if(selectedTab == "EmployeeComplianceConversion") {
		// 	getEmployeeComplianceConversion();
		// } else if(selectedTab == "ROComplianceConversion") {
		// 	getROComplianceConversion();
		// }
	}, [userRoles, selectedMonth, selectedTab, isCompliance]);

    function escapeCsvField(field) {
		if (field === null || field === undefined) return "";
		const fieldStr = field.toString();
		return fieldStr.replace(/[\n\r,\t]/g, " ");
		// if (fieldStr.includes('"')) {
		// 	// Escape double quotes
		// 	return `"${fieldStr.replace(/"/g, '""')}"`;
		// }
		// if (fieldStr.includes(",") || fieldStr.includes("\n") || fieldStr.includes("\t") || fieldStr.includes("\r")) {
		// 	// Wrap in double quotes if contains comma or newline
		// 	return `"${escaped}"`;
		// }
		// return fieldStr;
	}

    const handleDownloadReport = () => {
        const csvContent =
			"data:text/csv;charset=utf-8," +
			[
				"ID,Org Unit, Vendor Code, Vendor Name, Unit, SPOC, Email ID, Mobile No, Category, Exception Status, Year, Frequency, Acknowledgement No, Evidence, Updated On",
				...filteredData.map((item) =>
					[
						item.id,
						item.orgUnit,
						item.vendorCode,
						item.vendorName,
						item.unit,
						item.spoc,
						item.emailIds,
						item.mobileNos,
						item.category,
						item.exceptionFlag ? "Yes" : "No",
						item.year,
						item.frequency,
						item.acknowledgementNo,
                        item.selfAck ? (item.selfEvidence != null ? JSON.parse(item.selfEvidence)?.fileUrl : "Not Enough Permission") : "",
						moment(item.updatedOn).format("DD/MMM/YYYY HH:mm")
					].map(escapeCsvField).join(",")
				)
			].join("\n");
			
		const encodedUri = encodeURI(csvContent);
		const link = document.createElement("a");
		link.setAttribute("href", encodedUri);
		link.setAttribute("download", selectedTab + "_report.csv");
		document.body.appendChild(link);
		link.click();
    };

    const handleShowEmployeeDetailsModal = (year, vendorCode, vendorName) => {
    };

    const handleCloseDetailsModal = () => {
		setShowModal(false);
	};

    // Search Filters State
	const [filters, setFilters] = useState({
		// category: "",
		vendorCode: "",
		vendorName: "",
		orgUnit: "",
		unit: ""
	});

    // Define custom styles for the DataTable
	const customStyles = {
		headCells: {
			style: {
				fontSize: "16px", // Custom font size for header
				fontWeight: "bold", // Bold text for header
				backgroundColor: "#f4f4f4", // Light background color for the header
				color: "#333", // Text color
				textAlign: "center", // Center align the text
			},
		},
		cells: {
			style: {
				fontSize: "14px", // Adjust cell text size
				padding: "10px", // Add padding for readability
			},
		},
	};
	// Define table columns
	const columns = [
		{ name: "#", selector: (row, index) => index + 1, sortable: false },
		{ name: "Vendor Code", selector: (row) => row.vendorCode, sortable: true },
		{ name: "Vendor Name", selector: (row) => row.vendorName, sortable: true },
		{ name: "Org Unit", selector: (row) => row.orgUnit, sortable: true },
		{ name: "Unit", selector: (row) => row.unit, sortable: true },
		{ name: "Email Id", selector: (row) => row.emailIds, sortable: false },
		{ name: "Mobile No", selector: (row) => row.mobileNos, sortable: false },
        { name: "Category", selector: (row) => row.category, sortable: true },
        { name: "Frequency", selector: (row) => row.frequency, sortable: true },
        { name: "Exception Status", selector: (row) => row.exceptionFlag ? "Yes" : "No", sortable: true },
        { name: "Fin Year", selector: (row) => row.year, sortable: true },
        { name: "Acknowedged No", selector: (row) => row.acknowledgementNo, sortable: true },
        { name: "Evidence", selector: (row) => row.selfAck ? (row.selfEvidence != null ? <a href={JSON.parse(row.selfEvidence)?.fileUrl} target="_blank">View Evidence</a> : "Not Enough Permission") : "", sortable: false }
		// {
		// 	name: "Actions",
		// 	button: true,
		// 	cell: (row) => (
		// 		<div>
		// 			{/* Example action buttons */}
		// 			<Button
		// 				variant="info"
		// 				size="sm"
		// 				onClick={() =>
		// 					handleShowEmployeeDetailsModal(row.year, row.vendorCode, row.vendorName)
		// 				}
		// 			>
		// 				<FaInfoCircle /> {/* Use the information icon here */}
		// 			</Button>
		// 		</div>
		// 	),
		// },
	];

    // Apply search filters on button click
	const filteredData = tableData.filter(
		(item) =>
			// (!filters?.category ||
			// 	item?.category.toUpperCase().includes(filters?.category.toUpperCase())) &&
			(!filters.vendorCode ||
				item?.vendorCode.toUpperCase().includes(filters?.vendorCode.toUpperCase())) &&
			(!filters.vendorName ||
				item?.vendorName.toUpperCase().includes(filters?.vendorName.toUpperCase())) &&
			(!filters?.orgUnit ||
				item?.orgUnit.toUpperCase().includes(filters?.orgUnit.toUpperCase())) &&
			(!filters?.unit ||
				item?.unit.toUpperCase().includes(filters?.unit.toUpperCase()))
	);

    return (
        <div className="container mt-3 mb-3 d-flex flex-column min-vh-100">
            {/* Dashboard Title with Icon */}
            <h5 className="mb-3">
                <FaTachometerAlt className="me-2" /> Vendor Report
            </h5>

            {/* Buttons */}
            <Row className="mb-3">
                <Col md={12} className="d-flex align-items-center">
                    <Col md={3} className="me-2">
                        <label className="align-items-center">Financial Year: {finYear}</label>
                        <DatePicker selected={selectedMonth} onChange={(date) => setSelectedMonth(date)} dateFormat="MMMM yyyy" showMonthYearPicker className="form-control" />
                        {/* <span style={{fontSize: "13px", color: "red"}}>24th of {moment(selectedMonth).subtract(1, "M").format("MMMM YYYY")} to 23rd of {moment(selectedMonth).format("MMMM YYYY")}</span> */}
                    </Col>
                    <Col md={9} className="d-flex justify-content-end">
                        {/* <a href="/user-dashboard" className="me-3">
                            <Button variant="success" size="sm">
                                <FaUser className="me-2" /> Self Review
                            </Button>
                        </a>

                        {Array.isArray(userRoles) && userRoles.some(role => role.role === "RO") && (
                            <a href="/ro-dashboard" className="me-3">
                                <Button variant="success" size="sm">
                                    <FaUsers className="me-2" /> Team Review
                                </Button>
                            </a>
                        )}

                        {Array.isArray(userRoles) && userRoles?.some(role => role.role === "Payroll") && (
                            <a href="/payroll-dashboard" className="me-3">
                                <Button variant="info" size="sm">
                                    <FaUser className="me-2" /> Payroll View
                                </Button>
                            </a>
                        )} */}
                    </Col>
                </Col>
            </Row>

            {/* Tab View */}
            <Tabs activeKey={selectedTab} onSelect={(k) => setSelectedTab(k)} className="mb-3">
                <Tab eventKey="VendorNonCompliances" title="Vendor Non-Compliances Report" />
                <Tab eventKey="VendorCompliances" title="Vendor Compliances Report" />
                <Tab eventKey="ExceptionVendors" title="Exception Vendors Report" />
                {/* <Tab eventKey="ROHoldList" title="RO Hold List" />
                <Tab eventKey="EmployeeComplianceConversion" title="Employee Non-Compliance To Compliance" />
                <Tab eventKey="ROComplianceConversion" title="RO Non-Compliance To Compliance" /> */}
            </Tabs>

            
            <Card className="mt-3">
				<Card.Body>
                    {/* Header Row with Title & Buttons */}
					<Row className="mb-3 align-items-center">
						<Col md={6}>
                            {(selectedTab == "VendorNonCompliances") && (
                            <h5 className="mb-0">Vendor Non-Compliance - Report</h5>
                            )}
                            {(selectedTab == "VendorCompliances") && (
                            <h5 className="mb-0">Vendor Compliance - Report</h5>
                            )}
                            {(selectedTab == "ExceptionVendors") && (
                            <h5 className="mb-0">Exception Vendors - Report</h5>
                            )}
							{/* <span style={{ fontSize: "13px" }}>For current month only LIVE summary will show after 24th of current month & HOLD summary will show after action taken by Payroll team.</span> */}
						</Col>
						<Col md={6} className="d-flex justify-content-end">
							<Col md={5} className="me-2"></Col>
							<Col md={4} className="me-2">
								{/* <Button variant="info" className="me-2" onClick={handleEmpView}>
									{empTextButton}
								</Button> */}
							</Col>
							<Col md={3}>
								<Button variant="success" size="sm" className="me-2" onClick={handleDownloadReport}>
									Export to Excel
								</Button>
								{/* <Button variant="secondary" onClick={handlePrint}>
									Print
								</Button> */}
							</Col>
						</Col>
					</Row>
                    <Row className="mb-3">
						<Col md={12} className="d-flex align-items-center">
							<Col md={12} className="d-flex justify-content-end">
								<Button variant="primary" size="sm" className="me-2">
									Total Vendors{" "}
									<span className="badge bg-light text-dark ms-2">
										{totalVendorCount}
									</span>
								</Button>
								<Button variant="success" size="sm" className="me-2">
									Exception Vendors{" "}
									<span className="badge bg-light text-dark ms-2">
										{exceptionVendorCount}
									</span>
								</Button>
                                {(selectedTab == "VendorNonCompliances" || selectedTab == "VendorCompliances") && (
								<Button variant="warning" size="sm" className="me-2">
                                    {(selectedTab == "VendorNonCompliances") && (<>Non-Compliance{" "}</>)}
                                    {(selectedTab == "VendorCompliances") && (<>Compliance{" "}</>)}                                    																		
									<span className="badge bg-light text-dark ms-2">
										{reportCount}
									</span>
								</Button>
                                )}
							</Col>
						</Col>
					</Row>

                    {/* DataTable Integration */}
					<DataTable
						title=""
						columns={columns}
						data={filteredData} // Use filtered data
						pagination
						highlightOnHover
						responsive
					/>
                </Card.Body>
            </Card>


            <Modal show={showModal} onHide={handleCloseDetailsModal} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>{modalTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{modalContent}</Modal.Body>
            </Modal>
		</div>
	);

}

export default VendorReportPage;